import * as React from 'react'
import { SVGProps } from 'react'
const SvgCheckmark = (props: SVGProps<SVGSVGElement>) => (
  <svg width={17} height={17} viewBox="0 0 17 17" fill="none" {...props}>
    <circle cx={8.5} cy={8.5} r={8.5} fill="#427C54" />
    <path d="m5.666 8.765 1.985 2.213 4.213-5.312" stroke="#FAF6F0" />
  </svg>
)
export default SvgCheckmark
